import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="materials-filter" (on the <form> itself, see
// entries/_form.html.erb) — constrains every material line's "Material"
// combobox to the catalog of whichever freelancer is currently chosen in
// "Who did you work for?". Unlike Customer/Project, this never disables the
// field entirely: "Custom material" (data-constraint-exempt) stays pickable
// even with no freelancer chosen yet.
//
// There can be any number of material lines (added/removed freely), so
// #filter re-applies the constraint to every one currently in the DOM —
// including ones just cloned by materials#add, via "combobox:connect"
// bubbling up from their own combobox on insertion.
export default class extends Controller {
  static targets = ["freelancerHidden", "materialCombobox"]

  filter() {
    const freelancerId = this.freelancerHiddenTarget.value

    for (const element of this.materialComboboxTargets) {
      const combobox = this.application.getControllerForElementAndIdentifier(element, "combobox")
      if (!combobox) continue

      combobox.setConstraint("freelancerId", freelancerId, false)
    }
  }
}
